export enum CheckoutRedirectOrderStatus {
  FAIL = 'fail',
  SUCCESS = 'success',
  CANCEL = 'cancel',
}
